import * as React from 'react';
import { ProductInterface } from '../Model/Product';
import { Trans } from './Trans';

interface CalculatorLinkProps {
    product: ProductInterface
}

export class CalculatorLink extends React.PureComponent<CalculatorLinkProps, {}> {
    public render() {
        // eslint-disable-next-line react/jsx-no-target-blank
        return <a target="_blank"
                  href="https://calculator.fms-technology.com/"
                  className="pf-to-offer btn pf-to-offer-gray">
            <Trans id='general.calculator_link'>FMS-Calculator</Trans>
        </a>;
    }
}
